import { HttpInstance, HttpClientResponse, CacheOptions } from '@grupa-pracuj/http-client-relax';

export type EnvironmentData = {
  environment: string;
  appName: string;
  appVersion: string;
  homePageUrl: string;
  loginRedirectUrl: string;
  logoutRedirectUrl: string;
  changePasswordRedirectUrl: string;
  ssoLogoutUrl: string;
  apiGatewayAddress: string;
  apiConnectionTimeout: string;
  csrfCookieName: string;
  csrfHeaderName: string;
  cookieDomain: string;
  gtmContainerId: string;
  trackerCollectorEndpoint: string;
  trackerCoreUrl: string;
  trackerEnabled: string;
  onboardingProcessPageUrl: string;
  onboardingProcessCookieName: string;
  massachusettsGatewayAddress?: string;
};

export const defaultEnvironmentState: EnvironmentData = {
  environment: 'production',
  appName: '',
  appVersion: '',
  homePageUrl: 'https://pracuj.pl',
  loginRedirectUrl: '',
  logoutRedirectUrl: '',
  changePasswordRedirectUrl: '/',
  ssoLogoutUrl: '',
  apiGatewayAddress: '',
  apiConnectionTimeout: '',
  csrfCookieName: '',
  csrfHeaderName: '',
  cookieDomain: '.pracuj.pl',
  gtmContainerId: '',
  massachusettsGatewayAddress: '',
  trackerCollectorEndpoint: '',
  trackerCoreUrl: '',
  trackerEnabled: '',
  onboardingProcessPageUrl: 'https://onboarding.pracuj.pl',
  onboardingProcessCookieName: '',
};

const getEnvironment = (http: HttpInstance) => (): Promise<HttpClientResponse<EnvironmentData>> =>
  http.get('/api/private/variables', { cache: CacheOptions.Enabled });

export default getEnvironment;
